import { CATEGORY_BETRIEBSMEDIZIN_ID } from "@/helper/categoryIds";

export const OCCUPATIONAL_MEDICINE_COMPANY_APPOINTMENT_CONFIRMATION_KEY =
  "confirm_occupational_medicine_appointment_for_company";

type MainCategoryReference =
  | { id?: unknown; trace_id?: unknown }
  | string
  | null
  | undefined;

export const isOccupationalMedicineCategory = (
  category: MainCategoryReference,
): boolean => {
  const candidateIds =
    typeof category === "string"
      ? [category]
      : [category?.trace_id, category?.id];
  return candidateIds.some(
    (candidate) =>
      typeof candidate === "string" &&
      candidate.toLowerCase() === CATEGORY_BETRIEBSMEDIZIN_ID,
  );
};
